export default __webpack_public_path__ + "static/media/Inter-Regular.9cd7588f.ttf";